import styled from "styled-components";

export const Container = styled.div`
    margin-bottom: 2rem;

    .container{
        display: flex;
        align-items: center;
        margin: 1rem 0;
    }
`